// reportById
import { createSelector } from "reselect";

/**
 *
 * @param state
 */

const reportsSelector = (state: any) => state.features.reportById;

export const getBaseUrl = createSelector(
  reportsSelector,
  (app) => app.baseUrl
);

export const getinnerReportsData = createSelector(
  reportsSelector,
  (app) => app.reportData
);

export const getinnerReportState = createSelector(
  reportsSelector,
  (app) => app.reportState
);
export const getDetailsStates = createSelector(
  reportsSelector,
  (app) => app.reportState
);

export const getreportsLoadingState = createSelector(
    getinnerReportState,
  (reportState) => reportState.isLoading
);

export const getinnerReportLoadingState = createSelector(
  getDetailsStates,
  (reportState) => reportState.isLoading
);
